module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pledgeeName":"Pedgeee name"},"et":{"pledgeeName":"Pedgeee name"},"ru":{"pledgeeName":"Pedgeee name"}}')
  delete Component.options._Ctor
}
